/* eslint-disable react/prop-types */
import { Box, Grid } from "@mui/material";
import React, { useEffect, useState } from "react";
import moment from "moment/moment";
import InputField from "../../../components/common/new/InputField/InputField";
import { isEmptyObj } from "../../../utils/helper";
import Styles from "../../Reports/GohonzonReports/GohonzonSearch.styles";
import useParamsQuery from "../../../hooks/useParamsQuery";
import DateRangePicker from "../../../components/common/DateRangePicker/DateRangePicker";
import DropDownSelect from "../../../components/common/Dropdown";

const initialFormValue = {
  applicationFrom: moment().subtract(1, "months").format("YYYY-MM-DD"),
  applicationTo: moment().format("YYYY-MM-DD"),
  allotmentFrom: "",
  allotmentTo: "",
  conferredFrom: "",
  conferredTo: "",
};

const gohonzonTypeOptions = [
  { entityTitle: "Okataki gohonzon", value: "OKATAKI_GOHONZON" },
  { entityTitle: "Omamori gohonzon", value: "OMAMORI_GOHONZON" },
];

const commonFieldSx = {
  width: "100%",
  "& .MuiFormControl-root": {
    width: "100% !important",
  },
  "& .MuiOutlinedInput-root": {
    width: "100% !important",
    height: "42px !important",
    borderRadius: "8px",
    backgroundColor: "#fff",
  },
  "& .MuiInputBase-root": {
    width: "100% !important",
    height: "42px !important",
    boxSizing: "border-box",
  },
  "& .MuiInputBase-input": {
    height: "42px !important",
    boxSizing: "border-box",
    padding: "16.5px 14px !important",
    display: "flex",
    alignItems: "center",
  },
  "& .MuiOutlinedInput-notchedOutline": {
    borderColor: "rgba(0, 0, 0, 0.23) !important",
  },
  "& .MuiInputLabel-root": {
    background: "#fff",
    padding: "0 4px",
  },
  "& .MuiSelect-select": {
    minHeight: "unset !important",
    height: "42px !important",
    display: "flex",
    alignItems: "center",
    padding: "16.5px 14px !important",
    boxSizing: "border-box",
  },
  "& .MuiSvgIcon-root": {
    right: "12px",
  },
};

const cardStyle = {
  border: "1px solid #e0e0e0",
  borderRadius: "8px",
  padding: "16px",
  backgroundColor: "#fff",
  height: "100%",
  boxSizing: "border-box",
};

function PersonalDetailsSearch() {
  const { getQueryObject, getQueryParams, urlSearchParams } = useParamsQuery();
  const [selectedGohonzonTypes, setSelectedGohonzonTypes] = useState([]);
  const [memberId, setMemberId] = useState("");
  const [memberName, setmemberName] = useState("");

  const [initialAdvanceFormValue, setInitialAdvanceFormValue] =
    useState(initialFormValue);

  useEffect(() => {
    const queryObject = getQueryObject();
    if (!isEmptyObj(queryObject)) {
      const query = getQueryParams(queryObject)[0];
      Object.keys(initialFormValue).forEach((key) => {
        setInitialAdvanceFormValue((prev) => ({
          ...prev,
          [key]: query[key] ?? "",
        }));
      });
    } else {
      setInitialAdvanceFormValue(initialFormValue);
    }
  }, [urlSearchParams.toString()]);

  const startDateValue =
    memberId || memberName
      ? moment("2020-01-01").format("YYYY-MM-DD")
      : initialAdvanceFormValue.applicationFrom;

  return (
    <Box sx={{ width: "100%" }}>
      <Grid container spacing={2} sx={{ marginBottom: "16px" }}>
        {/* Card 1 — Member ID + Member Name */}
        <Grid item xs={12} sm={6} md={3}>
          <Box sx={cardStyle}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <InputField
                  label="Member ID"
                  name="memberId"
                  onChange={(e) => setMemberId(e.target.value)}
                  style={{ ...Styles.textfieldStyle, width: "100%" }}
                />
              </Grid>
              <Grid item xs={12}>
                <InputField
                  label="Member Name"
                  name="memberName"
                  onChange={(e) => setmemberName(e.target.value)}
                  style={{ ...Styles.textfieldStyle, width: "100%" }}
                />
              </Grid>
            </Grid>
          </Box>
        </Grid>

        {/* Card 2 — Gohonzon Type + Application Date */}
        <Grid item xs={12} sm={6} md={3}>
          <Box sx={cardStyle}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <Box sx={commonFieldSx}>
                  <DropDownSelect
                    title="Gohonzon Type"
                    name="type"
                    selectOptions={gohonzonTypeOptions}
                    value={selectedGohonzonTypes}
                    setValue={setSelectedGohonzonTypes}
                    style={{ width: "100%" }}
                  />
                </Box>
              </Grid>
              <Grid item xs={12}>
                <Box sx={commonFieldSx}>
                  <DateRangePicker
                    label="Application Date"
                    name="application"
                    startDateVal={startDateValue}
                    endDateVal={initialAdvanceFormValue.applicationTo}
                    maxDate={new Date()}
                  />
                </Box>
              </Grid>
            </Grid>
          </Box>
        </Grid>

        {/* Card 3 — Empty */}
        <Grid item xs={12} sm={6} md={3}>
          {/* <Box sx={{ ...cardStyle, display: { xs: "none", md: "block" } }} /> */}
        </Grid>

        {/* Card 4 — Empty */}
        <Grid item xs={12} sm={6} md={3}>
          {/* <Box sx={{ ...cardStyle, display: { xs: "none", md: "block" } }} /> */}
        </Grid>
      </Grid>
    </Box>
  );
}

export default PersonalDetailsSearch;
